export default __webpack_public_path__ + "static/media/arrow.df42a2c9.png";